import { render, staticRenderFns } from "./import-dialog.vue?vue&type=template&id=3c131817&scoped=true&"
import script from "./import-dialog.vue?vue&type=script&lang=ts&"
export * from "./import-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./import-dialog.vue?vue&type=style&index=0&id=3c131817&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c131817",
  null
  
)

export default component.exports